// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__36i_7","header":"ClearentDisclaimer_header__1gbDq","inner":"ClearentDisclaimer_inner__27sq4"};